import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import CalculationForm from './components/CalculationForm.vue';
import Fondovi from './components/FondoviEU.vue';
import Clanak from './components/Clanak.vue';

Vue.use(VueRouter)
const routes = [{
  path: '/',
  name: 'CalculationForm',
  component: CalculationForm,
},
  {
    path: '/fondovi',
    name: 'fondovi',
    component: Fondovi,
  },
  {
    path: '/clanak',
    name: 'clanak',
    component: Clanak,
  },
]

const router = new VueRouter({
  routes // short for `routes: routes`
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

